var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, useDisclosure } from 'shared/components/ui';
import { useLogout } from 'shared/hooks';
import { AutoLogoutModal, LogoutTime } from '../AutoLogoutModal';
import { MODAL_SESSION_MESSAGE_TIME, MODAL_SESSION_TITLE } from '../constants';
import { useFinishTime } from '../useFinishTime';
import { useSessionTimer } from './useSessionTimer';
var SessionLogout = function () {
    var disclosure = useDisclosure();
    var logout = useLogout();
    var signOut = function () {
        disclosure.onClose();
        logout();
    };
    var _a = useSessionTimer(disclosure, logout), disableModal = _a.disableModal, remainingTime = _a.remainingTime;
    var finishTime = useFinishTime(remainingTime);
    var finishTimeMessage = MODAL_SESSION_MESSAGE_TIME(finishTime);
    var close = function () {
        disclosure.onClose();
        disableModal();
    };
    var acknowledgeButton = _jsx(Button, __assign({ onClick: close }, { children: "Acknowledge" }));
    return (_jsx(AutoLogoutModal, __assign({}, disclosure, { title: MODAL_SESSION_TITLE, primaryButton: acknowledgeButton, signOut: signOut, onClose: close }, { children: _jsx(LogoutTime, { finishTimeMessage: finishTimeMessage, initialTime: remainingTime }) })));
};
export { SessionLogout };
